<script setup>
import { ref } from 'vue';
import AppMenuItem from './AppMenuItem.vue';

const model = ref([
  {
    label: 'Dashboards',
    icon: 'pi pi-home',
    items: [
      {
        label: 'Analytics',
        icon: 'pi pi-fw pi-home',
        to: '/dashboards/analytics'
      },
      {
        label: 'Sales',
        icon: 'pi pi-fw pi-image',
        to: '/dashboards/sales'
      },
      {
        label: 'Sass',
        icon: 'pi pi-fw pi-image',
        to: '/dashboards/sass'
      }
    ]
  },
  {
    label: 'E-Commerce',
    icon: 'pi pi-wallet',
    items: [
      {
        label: 'Overview',
        icon: 'pi pi-fw pi-angle-right',
        to: '/pages/overview'
      },
      {
        label: 'Storefront',
        icon: 'pi pi-fw pi-angle-right',
        to: '/pages/storefront'
      },
      {
        label: 'Product List',
        icon: 'pi pi-fw pi-angle-right',
        to: '/ecommerce/product-list'
      },
      {
        label: 'Product Overview',
        icon: 'pi pi-fw pi-angle-right',
        to: '/ecommerce/product-overview'
      },
      {
        label: 'Order History',
        icon: 'pi pi-fw pi-angle-right',
        to: '/ecommerce/order-history'
      },
      {
        label: 'Shopping Cart',
        icon: 'pi pi-fw pi-angle-right',
        to: '/ecommerce/shopping-cart'
      },
      {
        label: 'Checkout Form',
        icon: 'pi pi-fw pi-angle-right',
        to: '/ecommerce/checkout-form'
      }
    ]
  },
  {
    label: 'Gaming Gear',
    icon: 'pi pi-fw pi-cog',
    items: [
      { label: 'Keyboards', icon: 'pi pi-fw pi-angle-right', to: '/gaming-gear/keyboards' },
      { label: 'Headsets', icon: 'pi pi-fw pi-angle-right', to: '/gaming-gear/headsets' },
      { label: 'Mice', icon: 'pi pi-fw pi-angle-right', to: '/gaming-gear/mic' },
      { label: 'MousePads', icon: 'pi pi-fw pi-angle-right', to: '/gaming-gear/mouse-pads' },
      { label: 'Chairs', icon: 'pi pi-fw pi-angle-right', to: '/gaming-gear/chairs' },
      { label: 'Monitors', icon: 'pi pi-fw pi-angle-right', to: '/gaming-gear/monitors' },
      { label: 'Ambient Lighting', icon: 'pi pi-fw pi-angle-right', to: '/gaming-gear/ambient-lighting' },
      { label: 'Accessories', icon: 'pi pi-fw pi-angle-right', to: '/gaming-gear/accessories' },
      { label: 'Apparel | Gear', icon: 'pi pi-fw pi-angle-right', to: '/gaming-gear/apparel-gear' }
    ]
  },
  {
    label: 'Streaming Gear',
    icon: 'pi pi-fw pi-video',
    items: [
      { label: 'Lighting', icon: 'pi pi-fw pi-angle-right', to: '/streaming-gear/lighting' },
      { label: 'Capture', icon: 'pi pi-fw pi-angle-right', to: '/streaming-gear/capture' },
      { label: 'Steam Deck', icon: 'pi pi-fw pi-angle-right', to: '/streaming-gear/steam-desk' },
      { label: 'Audio', icon: 'pi pi-fw pi-angle-right', to: '/streaming-gear/audio' },
      { label: 'Cameras', icon: 'pi pi-fw pi-angle-right', to: '/streaming-gear/cameras' },
      { label: 'Multi Mount', icon: 'pi pi-fw pi-angle-right', to: '/streaming-gear/multi-mount' },
      { label: 'Green Screen', icon: 'pi pi-fw pi-angle-right', to: '/streaming-gear/green-screen' }
    ]
  },
  {
    label: 'PC Components',
    icon: 'pi pi-fw pi-box',
    items: [
      { label: 'Cases', icon: 'pi pi-fw pi-angle-right', to: '/pc-components/cases' },
      { label: 'Cpu Coolers', icon: 'pi pi-fw pi-angle-right', to: '/pc-components/cpu-coolers' },
      { label: 'Fans', icon: 'pi pi-fw pi-angle-right', to: '/pc-components/fans' },
      { label: 'Memory', icon: 'pi pi-fw pi-angle-right', to: '/pc-components/memory' },
      { label: 'Power Supply Units', icon: 'pi pi-fw pi-angle-right', to: '/pc-components/power-supply-units' },
      { label: 'Custom Cooling', icon: 'pi pi-fw pi-angle-right', to: '/pc-components/custom-cooling' },
      { label: 'Storage', icon: 'pi pi-fw pi-angle-right', to: '/pc-components/storage' },
      {
        label: 'Docks & Expansion Hubs',
        icon: 'pi pi-fw pi-angle-right',
        to: '/pc-components/docs-and-expansion-hubs'
      },
      { label: 'Accessories', icon: 'pi pi-fw pi-angle-right', to: '/pc-components/accessories' }
    ]
  },
  {
    label: 'Gaming PCs',
    icon: 'pi pi-fw pi-desktop',
    items: [
      { label: 'All Gaming PCs', icon: 'pi pi-fw pi-angle-right', to: '/gaming-pcs/all' },
      {
        label: 'Corsair One Gaming PCs',
        icon: 'pi pi-fw pi-angle-right',
        to: '/gaming-pcs/corsair-gaming-one-pcs'
      },
      { label: 'Monitors', icon: 'pi pi-fw pi-angle-right', to: '/gaming-pcs/monitors' },
      { label: 'Gaming Laptops', icon: 'pi pi-fw pi-angle-right', to: '/gaming-pcs/gaming-laptops' }
    ]
  },
  { label: 'Downloads', icon: 'pi pi-fw pi-download', to: '/downloads' },
  { label: 'Community', icon: 'pi pi-fw pi-users', to: '/community' }
]);
</script>

<template>
  <ul class="layout-menu">
    <template v-for="(item, i) in model" :key="item">
      <AppMenuItem :item="item" root :index="i" />

      <li class="menu-separator"></li>
    </template>
  </ul>
</template>
